import { UploadType } from '../../../../../consts/uploadType';
import { Accept } from 'react-dropzone';

export const useAllowedFileTypes = (uploadType: UploadType): Accept => {
  return {
    [UploadType.RegularAndRtk]: {
      'image/*': [],
    },
    [UploadType.Pano]: {
      'image/*': [],
    },
    [UploadType.Ppk]: {
      'image/*': [],
    },
    [UploadType.Lidar]: {
      'image/*': [
        '.mrk',
        '.rpt',
        '.clc',
        '.cli',
        '.dbg',
        '.imu',
        '.ldr',
        '.ldrt',
        '.rpos',
        '.rtb',
        '.rtk',
        '.rtl',
        '.rts',
        '.sig',
        '.csv',
        '.jpg',
        '.jpeg',
        '.cmi',
        '.obs',
        '.bin',
        '.idr',
        '.idrt',
      ],
    },
  }[uploadType];
};
